module.exports = __webpack_public_path__ + "img/o.9ad4f3d7.jpg";